import axios from "axios";
import Axios from "axios";

const fileDownload = require('js-file-download');

export function downloadURI(uri, name, headers = {}) {
  return new Promise((resolve) => {
    try {
      axios({
        url: uri,
        method: 'GET',
        responseType: 'blob',
        headers: {
          ...Axios.defaults.headers.common,
          ...headers,
          'AuthMode': 'firebase'
        },
      })
        .then(async (response) => {
          try {
            resolve()
            fileDownload(response.data, name)
          } catch (e) {
            resolve()
            window.open(uri, '_blank')
          }
          // const url = window.URL
          //   .createObjectURL(new Blob([response.data]));
          // const link = document.createElement('a');
          // link.href = url;
          //
          // link.setAttribute('download', name);
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
        })
    } catch (e) {
      window.open(uri, '_blank')

    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/urlUtils.js